import type { CrawlLane, CrawlTrigger, PlanTier, TaskType } from "./types";
import { LANE_PRIORITY } from "./constants";

const FREE_LANE: CrawlLane = "p3_free";
const INITIAL_PAID_LANE: CrawlLane = "p0_initial";

export function computeLane(
  _planTier: PlanTier,
  trigger: CrawlTrigger,
  taskType?: TaskType
): CrawlLane {
  if (trigger === "initial" || trigger === "manual_retry") {
    return INITIAL_PAID_LANE;
  }

  if (trigger === "depth_expansion" || trigger === "weekly_report") {
    return "p4_weekly";
  }

  if (taskType === "stories") {
    return "p1_hourly";
  }

  return "p2_daily";
}

export function lanePriority(lane: CrawlLane): number {
  return LANE_PRIORITY[lane];
}

export function isFreeLane(lane: CrawlLane): boolean {
  return lane === FREE_LANE;
}

export function formatScheduleWindow(date: Date): string {
  return date.toISOString().slice(0, 13);
}

export function buildIdempotencyKey(
  trackedAccountId: string,
  taskType: TaskType,
  trigger: CrawlTrigger,
  scheduledFor: Date,
  suffix?: string
): string {
  const window = formatScheduleWindow(scheduledFor);
  const base = `${trackedAccountId}:${taskType}:${trigger}:${window}`;
  return suffix ? `${base}:${suffix}` : base;
}
